import React, { useState } from "react";

import Box from "@mui/material/Box";

import "./Section3.scss";
import section_3 from "../assets/images/section-3.png";
import category_1 from "../assets/images/category_1.png";
import category_2 from "../assets/images/category_2.png";
import category_3 from "../assets/images/category_3.png";
import InformativeModal from "./overlayComponents/InformativeModal";
import useCalculateHeightRatio from "../customHooks/useCalculateHeightRatio";

const Section3 = ({ JSONData }: any) => {
  const { content, image_file_size } = JSONData;

  const { heightRatio } = useCalculateHeightRatio({
    sectionImageHeight: image_file_size,
  });

  const [selectedCategory, setSelectedCategory] = useState({});
  const [openModal, setOpenModal] = useState(false);

  const toggleModalHandler = (categoryData: any) => {
    setOpenModal(!openModal);
    setSelectedCategory(categoryData);
  };

  return (
    <Box
      id="How We Do It"
      className="section-3-container"
      style={{ backgroundImage: `url(${section_3})`, ...heightRatio }}
    >
      <h1 className="sub-header">{content.top_header}</h1>
      <h1>{content.main_header}</h1>
      <h1 className="sub-header description">{content.description}</h1>

      <Box className="category-handler">
        <Box>
          <img src={category_1} alt="category-1" />
        </Box>
        <Box>
          <img src={category_2} alt="category-2" />
        </Box>
        <Box>
          <img src={category_3} alt="category-3" />
        </Box>
      </Box>

      <InformativeModal
        openModal={openModal}
        toggleModalHandler={toggleModalHandler}
        messageData={selectedCategory}
      />
    </Box>
  );
};

export default Section3;
